var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{staticClass:"label-chip",attrs:{"color":this.displayStatus.color,"label":""}},[_c('v-icon',{attrs:{"left":""}},[_vm._v(" "+_vm._s(this.displayStatus.icon)+" ")]),_vm._v(" "+_vm._s(this.displayStatus.name)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }